import { useTranslation } from "react-i18next";
import Footer from "../components/Footer";
import Header from "../components/Header";
import Title from "../components/Title";
import { CONTACT_PATH } from "../Routes/paths";
import { useNavigate } from "react-router-dom";
import Contact from "../components/Contact";

interface SearchEngineOptimizationsProps {}

const SearchEngineOptimizations = ({}: SearchEngineOptimizationsProps) => {
  const { i18n, t } = useTranslation();
  const navigate = useNavigate();
  return (
    <>
      <Header />
      <main
        className={`w-full ${
          i18n.language === "en" ? "font-Poppins" : "font-Almarai"
        }`}
      >
        {/* hero section  *****************************/}
        <Title
          title={t("Search Engine Optimization")}
          subtitle={t("Services")}
          thirdTitle={t("Search Engine Optimization")}
        />
        {/* next section  ******************************/}
        <section className="my-[20px] px-[20px] w-full flex flex-col items-center justify-center gap-8 lg:gap-0 lg:flex-row lg:items-center lg:justify-around ">
          <div>
            <img src="../images/SearchEngineOptimization.png" alt="" />
          </div>
          <div>
            <p
              className={`max-w-[800px] font-[500] lg:text-[14px] text-center ${
                i18n.language === "en" ? "lg:text-left" : "lg:text-right"
              }`}
            >
              {t(
                "Search engine use has gone mainstream; 91% of Internet users use search engines regularly. node.ae – Abu Dhabi Search Engine Optimization have proven results on how to gain SEO popularity. The first proof is that you are here. Our tailored SEO strategies ensure increased visibility and higher rankings on search engine results pages (SERPs). We optimize your website's content and structure to attract organic traffic and boost your online presence. With comprehensive keyword research and effective SEO techniques, we drive qualified leads to your business. Partner with node.ae and unlock the full potential of your online visibility through strategic SEO practices."
              )}
            </p>
          </div>
        </section>

        {/*  Our core service is developing **************/}
        <section className="my-[100px] px-[20px] lg:px-[140px] w-full flex flex-col gap-10 items-center justify-center">
          <p className="font-[700] text-[24px] lg:text-[28px] flex items-center justify-center">
            {t("The benefits of SEO")}
          </p>
          <div className="w-full h-[65px] rounded-[20px] bg-gradient-to-r from-[#E4002F] to-[#0804B5] flex items-center justify-center text-[12px] lg:text-[20px] font-[500] text-white text-center">
            {t("Optimize your website for all major search engines.")}
          </div>
          <div className="w-full h-[65px] rounded-[20px] bg-gradient-to-r from-[#E4002F] to-[#0804B5] flex items-center justify-center text-[12px] lg:text-[20px] font-[500] text-white text-center">
            {t(
              "Build professional recognizable image through the cyber world."
            )}
          </div>
          <div className="w-full h-[65px] rounded-[20px] bg-gradient-to-r from-[#E4002F] to-[#0804B5] flex items-center justify-center text-[12px] lg:text-[20px] font-[500] text-white text-center">
            {t(
              "Monitor regularly whether you are getting desired ranking against desired keywords."
            )}
          </div>
        </section>

        {/* Connect With Us: Your Voice Heard **************/}
        <Contact />
      </main>
      <Footer />
    </>
  );
};

export default SearchEngineOptimizations;
